import { createTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { GridOverlay } from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import * as React from "react";
import ErrorMessage from "./ErrorMessage";

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        flexDirection: "column",
      },
      label: {
        marginTop: theme.spacing(1),
      },
    }),
  { defaultTheme }
);

export default function CustomErrorTableOverlay(props) {
  const classes = useStyles();

  return (
    <GridOverlay className={classes.root}>
      <ErrorMessage errorMessage={props.errorMessage} errorCode={props.errorCode} />
    </GridOverlay>
  );
}

CustomErrorTableOverlay.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  errorCode: PropTypes.string.isRequired,
};
